import { CardStep, CardStepMovile } from "./StepsCard.styled";
import Text from "../Text";
import { Column, Row } from "../Grid";
import Image from "../Image";
import { StepsProps } from "../../Models/StepsCard";
import Title from "../Title";
import isEmpty from "lodash.isempty";

const StepsCard = ({ image, title, text }: StepsProps) => {
  return (
    <>
      <CardStep text={text}>
        <Row>
          <Column span={6}>
            {!isEmpty(title) && (
              <Title
                size={9}
                color="Primary_600"
                align="left"
                tagName="h1"
                text={title}
                margin="0 0 12px 120px"
              />
            )}
            {!isEmpty(text) && (
              <Text
                size={5}
                color="Eerie_Black"
                align="left"
                margin="0 0 0 120px"
                weight={600}
              >
                {text}
              </Text>
            )}
          </Column>
          <Column span={6}>
            <Image srcImg={image} marginImg="30px 0" />
          </Column>
        </Row>
      </CardStep>
      <CardStepMovile text={text}>
        {!isEmpty(title) && (
          <Title
            size={3}
            color="Primary_600"
            align="center"
            tagName="h1"
            text={title}
          />
        )}
        {!isEmpty(text) && (
          <Text size={3} color="Eerie_Black" align="center" weight={600}>
            {text}
          </Text>
        )}
      </CardStepMovile>
    </>
  );
};

export default StepsCard;
